// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { TemplateType } from './TemplateType';
/**
 * 代码模板 实体类
 * 生成代码的预置模板
 */
export class CodeTemplate extends BaseEntity {
  /** 名称 : 名称 */
  private _name: string;

  /** 设置：名称 */
  public get name() {
    return this._name;
  }

  /** 获取：名称 */
  public set name(value: string) {
    this._name = value;
  }

  /** 编码 : 代码模板的编码，全局唯一 */
  private _code: string;

  /** 设置：编码 */
  public get code() {
    return this._code;
  }

  /** 获取：编码 */
  public set code(value: string) {
    this._code = value;
  }

  /** 描述 : 描述 */
  private _description: string;

  /** 设置：描述 */
  public get description() {
    return this._description;
  }

  /** 获取：描述 */
  public set description(value: string) {
    this._description = value;
  }

  /** 模板分类 的ID */
  private _templateType_ID: string;

  /** 获取：模板分类 的ID */
  public get templateType_ID() {
    return this._templateType_ID;
  }

  /** 设置：模板分类 的ID */
  public set templateType_ID(value: string) {
    this._templateType_ID = value;
  }

  /** 模板分类  */
  private _templateType: TemplateType;

  /** 获取：模板分类  */
  public get templateType() {
    return this._templateType;
  }

  /** 设置：模板分类  */
  public set templateType(value: TemplateType) {
    this._templateType = value;
    if (value !== null) {
      this.templateType_ID = value.id;
    } else {
      this.templateType_ID = '';
    }
  }

  constructor() {
    super();
    this._name = '';
    this._code = '';
    this._description = '';
    this._templateType_ID = '';
    this._templateType = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: CodeTemplate, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.name = element.name;
      this.code = element.code;
      this.description = element.description;
      this.templateType_ID = element.templateType_ID;
      if (hasReference && element.templateType !== null) {
        this.templateType = element.templateType;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.name = json.Name;
    this.code = json.Code;
    this.description = json.Description;
    this.templateType_ID = json.TemplateType_ID;
    // if (json.TemplateType !== null) {
    //   this.templateType = TemplateType.Create(json.TemplateType);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Name = this.name;
    json.Code = this.code;
    json.Description = this.description;
    json.TemplateType_ID = this.templateType_ID;
  }

  static Create(json: any): CodeTemplate {
    const codeTemplate = new CodeTemplate();
    codeTemplate.Deserialize(json);
    codeTemplate.json = json;
    return codeTemplate;
  }
}
